import { Label, TextField } from "@towersystems/roam-common-native";
import { Controller, useFormContext } from "react-hook-form";
import { View } from "react-native-ui-lib";
import { OrderItemFormValues } from "../../types";
import { useTranslation } from "../../../../../../utilities/i18n";

export interface QuantityFormInputProps {}

export const QuantityFormInput = ({}: QuantityFormInputProps) => {
  const { control } = useFormContext<OrderItemFormValues>();
  const { t } = useTranslation("stockorder");

  return (
    <View>
      <Label label={t("form.quantity.label")}></Label>
      <Controller
        name="quantity"
        control={control}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <TextField
            value={value}
            onChangeText={onChange}
            validationMessage={error ? error.message : undefined}
            placeholder={t("form.quantity.placeholder")}
            keyboardType="numeric"
          />
        )}
      />
    </View>
  );
};
